import React from "react";

import { Box, Text, Button } from "@showitinc/showit-wc";
import AppConstants from "../constants/AppConstants";
import ShowitLogoName from "./ShowitNameLogo";
import desktopLgImage from "../../assets/img/desktop-lg.svg";
import chromeSafariImage from "../../assets/img/chrome-safari.png";
import styles from "./UnsupportedBrowserView.module.css";

const { CHROME_UPDATE_HELP_URL, SUPPORTED_BROWSERS_HELP_DOC_URL } = AppConstants;

const UnsupportedBrowserView = ({ reasonNotSupported = "browser" }) => {
  const _openWindow = (url) => window.open(url);

  const config = {
    browser: {
      content: (
        <>
          Showit is made for Google Chrome<br />
          on desktop. You can also try out the<br />
          beta version for Safari.{" "}
          <a href={SUPPORTED_BROWSERS_HELP_DOC_URL}>Learn more</a>
          <br />
        </>
      ),
      ctaButtonDisabled: true
    },
    version: {
      header: "Chrome Update Required",
      content: (
        <>
          Showit uses some super-fancy stuff that's only available in the latest version of{" "}
          <a href={CHROME_UPDATE_HELP_URL}>Google Chrome</a> for desktop. <br /> Please update
          Chrome, login to Showit, and create something that will make the world more awesome.
        </>
      ),
      ctaButtonDisabled: false,
      ctaText: "Get Update Instructions",
      ctaLink: CHROME_UPDATE_HELP_URL,
    },
  };

  return (
    <Box className="view-centered" d="flex" justify="center" align="center">
      <Box className={styles.viewCentered} d="flex" flex="col" justify="center" align="center">
        <ShowitLogoName />
        {
          config[reasonNotSupported].ctaButtonDisabled && (
            <>
            <Box mb="3" className={styles.imageContainer}>
              <img src={desktopLgImage} alt="Desktop illustration" className={styles.desktopImage} />
              <img src={chromeSafariImage} alt="Chrome Safari" className={styles.chromeSafariImage} />
            </Box>
            </>
          )
        }
        <Box mb="3">
          <Text variant="title-hero" variant-style="strong">
            {config[reasonNotSupported].header}
          </Text>
        </Box>
        <Box mb="3">
          <Box className={styles.bodyTextWrapper}>
            <Text className={styles.bodyText} variant="body-large">
              {config[reasonNotSupported].content}
            </Text>
          </Box>
        </Box>
        {
          !config[reasonNotSupported].ctaButtonDisabled && (
            <>
            <Box>
              <Button
                variant="feature"
                size="lg"
                fullWidth
                onClick={() => _openWindow(config[reasonNotSupported].ctaLink)}
              >
                {config[reasonNotSupported].ctaText}
              </Button>
            </Box>
            <Box mt="3">
              <Button variant="link" onClick={() => _openWindow("https://showit.com/")}>
                Learn more about Showit
              </Button>
            </Box>
            </>
          )
        }
      </Box>
    </Box>
  );
};

export default UnsupportedBrowserView;
